import { render, staticRenderFns } from "./aiSuggestDialogue.vue?vue&type=template&id=105cb657&scoped=true"
import script from "./aiSuggestDialogue.vue?vue&type=script&lang=js"
export * from "./aiSuggestDialogue.vue?vue&type=script&lang=js"
import style0 from "./aiSuggestDialogue.vue?vue&type=style&index=0&id=105cb657&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105cb657",
  null
  
)

export default component.exports